import s from './Footer.module.scss';
import { ContentContainer } from '../ContentContainer';
import { Logo } from '../Logo';
import privacyPolicy from 'documents/Политика_конфиденциальности.pdf';

export const Footer = () => {
	return (
		<ContentContainer>
			<footer className={s.footer}>
				<Logo className={s.logo} />
				<span>Все права защищены 2024.</span>
				<div>
					<a href='/legalInfo'>Юридическая информация</a>
					<a href={privacyPolicy} target='_blank'>
						Конфиденциальность
					</a>
					<a href='#'>Обработка персональных данных</a>
				</div>
			</footer>
		</ContentContainer>
	);
};
